




































































































































































































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { AxiosVue } from '@/AxiosVue';
import { fetchAltaServicio } from './fetchAltaServicio';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import modalDetalleAltaServicio from '@/pantallas/Conecta/AltasServicio/ModalVerDetalleAlta.vue'; /* */
import modalVerDetalleAltaServicio from '@/pantallas/Conecta/AltasServicio/ModalVerDetalleAlta.vue';
import moment from 'moment';

import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';

import DownloadIcon from './DownloadIcon.vue';
import ModalEditarAlta from './ModalEditarAlta.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    modalVerDetalleAltaServicio,
    DownloadIcon,
    ModalEditarAlta,
  },
})
export default class AltasDeServicio extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.AltasDeServicio;

  /*@Prop({ default: null }) filtro_cliente: any;
  @Prop({ default: null }) filtro_tecnico: any;
  @Prop({ default: null }) filtro_flota: any;
  @Prop({ default: null }) filtro_equipo: any;
  @Prop({ default: null }) filtro_inicio: any;
  @Prop({ default: null }) model_tipo_fecha: any = 'fecha_instalacion';
  @Prop({ default: null }) filtro_tipo_fecha: any;
  @Prop({ default: null }) filtro_coordinador: any;
  @Prop({ default: null }) accion_modal: String;
*/

  filtro_cliente: any[] = [];
  filtro_tecnico: any[] = [];
  filtro_flota: any[] = [];
  filtro_equipo: any[] = [];
  filtro_inicio: any = null;
  model_tipo_fecha: any = 'fecha_instalacion';
  filtro_tipo_fecha: any[] = [];
  filtro_coordinador: any[] = [];
  accion_modal: String = '';
  model_filtro_alta: any = null;
  model_filtro_anulado: any = null;
  filtro_tipo_alta: { tipoAltaId: string; tipoAlta: string }[] = [
    { tipoAltaId: 'actualizaAlta', tipoAlta: 'INSTALACIÓN' },
    { tipoAltaId: 'actualizademoRecuperacion', tipoAlta: 'DEMO/RECUPERACIÓN' },
  ];
  filtroAnulado: { anuladoId: string; anulado: string }[] = [
    { anuladoId: 'true', anulado: 'SI' },
    { anuladoId: 'false', anulado: 'NO' },
  ];
  altasservicio: any = [];
  gridApi: GridApi = null;
  model_filtro_cliente: any = null;
  model_filtro_tecnico: any = null;
  model_filtro_flota: any = null;
  model_filtro_patente: any = null;
  model_filtro_equipo: any = null;
  model_filtro_inicio: any = null;
  model_filtro_tipo_alta: any = null;
  model_filtro_fin: any = null;
  model_filtro_coordinador: any = null;
  AltaServicio_Seleccionada: any = null;
  numero_orden_Seleccionada: any = null;
  AltaServicioModalState: boolean = false;
  showReporteGenerado: boolean = false;
  esEdicion: boolean = false;
  texto_reporte: string = 'TEXTO CUERPO MODAL';
  data: any = {};
  dialogModalEditar: boolean = false;
  titleStartDate: string = 'Fecha de Instalación Desde';
  titleEndDate: string = 'Fecha de Instalación Hasta';
  flotaName: string = 'Flota';

  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionVerDetalle, this.accionEditar];

  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handlerbuttonmodalVerDetalle);
    actionsEvent.onEditar(this.handleEditar);
  }

  updateDateTypeFilter() {
    this.titleStartDate =
      this.model_tipo_fecha === 'fecha_instalacion'
        ? 'Fecha de Instalación Desde'
        : 'Fecha de Registro Desde';
    this.titleEndDate =
      this.model_tipo_fecha === 'fecha_instalacion'
        ? 'Fecha de Instalación Hasta'
        : 'Fecha de Registro Hasta';
  }

  @Watch('model_filtro_inicio')
  handlerStartDate() {
    if (this.model_filtro_inicio > this.model_filtro_fin) {
      this.model_filtro_fin = this.model_filtro_inicio;
    }
  }

  @Watch('model_filtro_fin')
  handlerEndDate() {
    if (this.model_filtro_fin < this.model_filtro_inicio) {
      this.model_filtro_inicio = this.model_filtro_fin;
    }
  }

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Número Orden',
        field: 'Número Orden',
        width: 190,
      },
      {
        headerName: 'Número de Alta',
        field: 'Número de Alta',
        width: 150,
      },
      {
        headerName: 'Tipo de Alta',
        field: 'tipo_alta',
        width: 150,
      },
      {
        headerName: 'Fecha de Registro',
        field: 'Fecha de Registro',
        width: 170,
      },
      {
        headerName: 'Fecha Instalación',
        field: 'Fecha Instalación',
        width: 170,
      },
      {
        headerName: 'Coordinador',
        field: 'Coordinador',
        width: 160,
      },
      {
        headerName: 'Técnico',
        field: 'Técnico',
        width: 170,
      },
      {
        headerName: 'Cliente',
        field: 'Cliente',
        width: 180,
      },
      {
        headerName: 'Flota',
        field: 'Flota',
        width: 160,
      },
      {
        headerName: 'Patente',
        field: 'Patente',
        width: 140,
      },
      {
        headerName: 'Marca Vehículo',
        field: 'Marca Vehículo',
        width: 140,
      },
      {
        headerName: 'Modelo Vehículo',
        field: 'Modelo Vehículo',
        width: 140,
      },
      {
        headerName: 'Año Vehículo',
        field: 'Año Vehículo',
        width: 140,
      },
      {
        headerName: ' Anulada',
        field: 'Anulada',
        width: 140,
      },
      {
        headerName: 'Reemplaza',
        field: 'Reemplaza',
        width: 140,
      },
      {
        headerName: 'Estado',
        field: 'Estado',
        width: 140,
      },
      {
        headerName: 'Ver Informe',
        field: 'informepdf',
        lockPinned: true,
        sortable: false,
        resizable: false,
        cellStyle: { display: 'grid', placeItems: 'center' },
        width: 140,
        cellRendererFramework: DownloadIcon,
        cellRendererParams: (params: any) => ({
          data: params.data,
        }),
      },
    ].map(x => ({
      minWidth: 100,
      hide: false,
      resizable: true,
      cellStyle: { textAlign: 'left' },
      ...x,
    })),
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 50,

    onGridReady: this.handleGridReady,
  };

  handleDownloadReport(params: any): void {
    this.downloadReport(params);
  }

  handlerbuttonmodalVerDetalle(params: ICellRendererParams) {
    this.data = params.data;
    this.AltaServicio_Seleccionada = params.data['Número'];
    this.numero_orden_Seleccionada = params.data['Número Orden'];
    this.AltaServicioModalState = true;
    this.esEdicion = false;
    this.accion_modal = 'EDITAR';
  }

  handleEditar(params: any) {
    this.data = params.data;
    this.dialogModalEditar = true;
    this.esEdicion = true;
  }

  handlerbuttonmodal() {
    this.AltaServicio_Seleccionada = null;
    this.numero_orden_Seleccionada = null;
    this.AltaServicioModalState = true;
    this.accion_modal = 'CREAR';
  }

  async modalverDetalleCallback(event: any) {
    this.AltaServicioModalState = event;
    this.altasservicio = await this.get_grid_data_altas_servicio();
    this.gridApi.setRowData(this.altasservicio);
    this.copy_scroll();
  }

  async handleGridReady(event: GridReadyEvent) {
    await this.getFilters();
    this.altasservicio = await this.get_grid_data_altas_servicio();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.altasservicio);
    this.gridApi.setDomLayout('autoHeight');
    this.copy_scroll();
    this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
  }

  copy_scroll() {
    setTimeout(() => {
      if (
        document.querySelectorAll<HTMLElement>(
          '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll'
        ).length > 1
      ) {
        document
          .querySelectorAll<HTMLElement>(
            '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll'
          )[0]
          .remove();
      }
      if (
        document.querySelectorAll<HTMLElement>(
          '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll'
        ).length == 1
      ) {
        document
          .querySelector<HTMLElement>(
            '.asignacionNoSeriado .ag-root-wrapper-body .ag-root.ag-unselectable.ag-layout-auto-height'
          )
          .prepend(
            document
              .querySelector<HTMLElement>(
                '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll'
              )
              .cloneNode(true)
          );

        document
          .querySelectorAll<HTMLElement>(
            '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
          )[0]
          .addEventListener('scroll', function() {
            let x = document.querySelectorAll<HTMLElement>(
              '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
            )[0].scrollLeft;
            document.querySelectorAll<HTMLElement>(
              '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
            )[1].scrollLeft = x;
          });

        document
          .querySelectorAll<HTMLElement>(
            '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
          )[1]
          .addEventListener('scroll', function() {
            let x = document.querySelectorAll<HTMLElement>(
              '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
            )[1].scrollLeft;
            document.querySelectorAll<HTMLElement>(
              '.asignacionNoSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
            )[0].scrollLeft = x;
          });
      }
      document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .ag-root-wrapper-body .ag-horizontal-right-spacer'
      )[0].style.width = document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .ag-root-wrapper-body .ag-horizontal-right-spacer'
      )[1].style.width;
      document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .ag-root-wrapper-body .ag-horizontal-right-spacer'
      )[0].style.minWidth = document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .ag-root-wrapper-body .ag-horizontal-right-spacer'
      )[1].style.minWidth;
      document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .ag-root-wrapper-body .ag-horizontal-right-spacer'
      )[0].style.maxWidth = document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .ag-root-wrapper-body .ag-horizontal-right-spacer'
      )[1].style.maxWidth;
    }, 3000);
  }

  async applyfilters() {
    let body: { [key: string]: string } = {
      filtro_cliente: this.model_filtro_cliente,
      filtro_equipo: this.model_filtro_equipo,
      filtro_flota: this.model_filtro_flota,
      filtro_tipo_fecha: this.model_tipo_fecha,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_patente: this.model_filtro_patente,
      filtro_tecnico: this.model_filtro_tecnico,
      filtro_coordinador: this.model_filtro_coordinador,
      filtro_alta: this.model_filtro_alta,
      filtro_tipoAlta: this.model_filtro_tipo_alta,
      filtro_anulado: this.model_filtro_anulado,
    };
    this.altasservicio = await this.get_grid_data_altas_servicio(body);
    this.gridApi.setRowData(this.altasservicio);
    this.copy_scroll();
  }

  async cleanfilters() {
    this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
    this.model_filtro_cliente = null;
    this.model_filtro_equipo = null;
    this.model_filtro_equipo = null;
    this.flotaName = 'Flota';
    //this.model_filtro_inicio = null;
    //this.model_filtro_fin = null;
    this.model_filtro_patente = null;
    this.model_filtro_tecnico = null;
    this.model_tipo_fecha = 'fecha_instalacion';
    this.model_filtro_flota = null;
    this.model_filtro_alta = null;
    this.model_filtro_coordinador = null;
    this.model_filtro_tipo_alta = null;
    this.model_filtro_anulado = null;
    this.altasservicio = await this.get_grid_data_altas_servicio();
    this.gridApi.setRowData(this.altasservicio);
    this.copy_scroll();
  }

  async btn_exportar(tipo: string = 'csv') {
    let body: { [key: string]: string } = {
      filtro_cliente: this.model_filtro_cliente,
      filtro_equipo: this.model_filtro_equipo,
      filtro_flota: this.model_filtro_flota,
      filtro_alta: this.model_filtro_alta,
      filtro_tipo_fecha: this.model_tipo_fecha,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_patente: this.model_filtro_patente,
      filtro_tecnico: this.model_filtro_tecnico,
      filtro_coordinador: this.model_filtro_coordinador,
      tipo_informe: tipo,
    };
    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchAltaServicio(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
      },
      'conecta_altas_servicio/exportar'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('btn_exportar');
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  async handleCloseModal(reload: boolean = false) {
    this.dialogModalEditar = false;
    this.data = {};
    if (reload) {
      this.altasservicio = await this.get_grid_data_altas_servicio();
      this.gridApi.setRowData(this.altasservicio);
      this.gridApi.setDomLayout('autoHeight');
      this.copy_scroll();
    }
  }

  handleFLotasFilter() {
    if (this.model_filtro_cliente) {
      this.flotaName = 'Flota Cliente';
      return this.getFilterFlota({
        tag: 'only_flota_id',
        clienterut: this.model_filtro_cliente,
      });
    }
    this.flotaName = 'Flota';
    return this.getFilterFlota({ tag: 'all_flotas' });
  }

  async getFilterFlota({
    tag,
    clienterut = '',
  }: {
    tag: string;
    clienterut?: string;
  }): Promise<void> {
    try {
      this.loadingService.showLoading();
      const result = await fetchAltaServicio(
        {
          tag,
          clienterut,
        },
        'conecta_altas_servicio/get_filters2'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FLOTAS } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.filtro_flota = FLOTAS;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async get_grid_data_altas_servicio(filter_data: any = null) {
    if (filter_data == null) {
      filter_data = { '': '' };
    }
    this.loadingService.showLoading(undefined, 'get_grid_data_altas_servicio');
    return fetchAltaServicio(filter_data, 'conecta_altas_servicio')
      .then((data: any) => {
        return data.data.data.LISTA;
      })
      .catch((error: any) => null)
      .finally(() =>
        this.loadingService.hideLoading('get_grid_data_altas_servicio')
      );
  }

  async getFilters(): Promise<void> {
    try {
      this.loadingService.showLoading(undefined, 'getFilters');
      const result = await fetchAltaServicio(
        {},
        'conecta_altas_servicio/get_filters'
      );
      this.filtro_cliente = result.data.CLIENTES.LISTA;
      this.filtro_tecnico = result.data.TECNICOS.LISTA;
      this.filtro_flota = result.data.FLOTAS.LISTA;
      this.filtro_equipo = result.data.EQUIPO.LISTA;
      this.filtro_tipo_fecha = result.data.TIPO_FECHA_FILTRO;
      this.filtro_coordinador = result.data.COORDINADORES.LISTA;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 300 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 300 }
      );
    } finally {
      this.loadingService.hideLoading('getFilters');
    }
  }

  async downloadReport(params: any) {
    try {
      this.loadingService.showLoading();
      const result = await fetchAltaServicio(
        { ...params },
        'conecta_altas_servicio/download_report'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, URL } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      // Crea un enlace temporal y simula un clic para descargar el archivo
      const $a = document.createElement('a') as HTMLAnchorElement;
      $a.href = `${process.env.VUE_APP_SERVICIO_MS}track/view?url=${btoa(
        URL
      )}&download=SI`;
      $a.style.display = 'none';
      document.body.appendChild($a);
      $a.click();
      document.body.removeChild($a);
      this.$snotify.success(MENSAJE_RESPUESTA);
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 300 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 300 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }
  /*

  async get_listas_por_cliente() {
    this.filtro_cliente = null;
    this.loadingService.showLoading(undefined, 'get_vehiculos_por_cliente');
    return fetchAltaServicio(
      { id_cliente: this.filtro_cliente,id_flota: this.model_filtro_flota },
      'conecta_altas_servicio/get_listas_por_cliente_ms'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_vehiculos_por_cliente');
        this.model_filtro_patente = data.data.VEHICULOS.LISTA;
        this.model_filtro_flota = data.data.FLOTAS.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });

  }
  */
}
